import { httpGet } from '@inner-source/cis-shared/transports';

const getProjectsWithDoneIssues = async ({ limit = 5 } = {}) => httpGet('/get-projects-with-done-issues', { limit });

export default getProjectsWithDoneIssues;
